import { faRectangleList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import InsightsIcon from "@mui/icons-material/Insights";
import {
  Alert,
  Button,
  CircularProgress,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import EditNoteDialog from "../../../dialogs/EditNoteDialog";
import { Box, Stack } from "@mui/system";
import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showInsufficientCreditsModal } from "../../../actions/creditActions";
import { deductCredits } from "../../../utils/HelperFunction/deductCredits";
import {
  removeNote,
  updateNote,
} from "../../../store/Bookmarks/bookmarksActions";
import CaseLawPreviewDialog from "../../../dialogs/CaseLawPreviewDialog";
import CaseSummaryDialog from "../../../dialogs/CaseSummaryDialog";
import CaseDetailDialog from "../../../dialogs/CaseDetailDialog";
import { CMSContext } from "../context/CaseManagmentContext";
import { Delete } from "@mui/icons-material";
import { red } from "@mui/material/colors";
import ConfirmationDialog from "../../../dialogs/ConfirmationDialog";
import { toast } from "react-toastify";
import { formatCourtName } from "../../../utils/HelperFunction/textFormatting";
import { deleteCaseReferenceApi } from "../../../services/api/caseManagementApi";
const formatCaseTitle = (title) => {
  if (!title) return;
  const splitTitle = title?.split("Honorable")[0];
  const titleCaseTitle = splitTitle
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
  return titleCaseTitle;
};
export const CaseReferenceTable = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [refCase, setRefCase] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [editNoteItem, setEditNoteItem] = useState(null);
  const [openCaseInsights, setOpenCaseInsights] = useState(false);
  const [selectItem, setSelectItem] = useState([]);
  const [openSummary, setOpenSummary] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState(null);
  const dispatch = useDispatch();
  const [refCaseToDelete, setRefCaseToDelete] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const credits = useSelector((state) => state.credit.credits);
  const userId = useSelector((state) => state.credit.userId);
  const { fetchingRefCase, refCases, selectedCase, setRefCases } =
    useContext(CMSContext);
  const [loading, setLoading] = useState(false);

  const handlePreviewClick = (item) => {
    let creditsToDeduct = 1;
    if (credits <= 0 || credits <= creditsToDeduct) {
      dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
      return;
    }
    if (item.type === "case") {
      setRefCase(item);
      setOpenPreview(true);
    }
    const deductionSuccess = deductCredits(
      { userId, creditsToDeduct: 1, event: "Preview Bookmarked Document" },
      dispatch
    );

    if (!deductionSuccess) {
      console.warn(
        "Failed to deduct credits. Ensure retry or user notification."
      );
    }
  };

  const handleSummaryClick = async (item) => {
    setSelectItem(item);
    setOpenSummary(true);
  };

  const handleDelete = async () => {
    if (!refCaseToDelete || !selectedCase) return;

    let creditsToDeduct = 1;
    if (credits <= 0 || credits < creditsToDeduct) {
      dispatch(showInsufficientCreditsModal());
      return;
    }

    try {
      setLoading(true);

      const response = await deleteCaseReferenceApi(selectedCase._id, refCaseToDelete.Bookmark_ID);

      if (response.status !== 200) {
        toast.error("Failed to delete the reference case");
        throw new Error("Failed to delete the reference case");
      }

      setRefCases((prevCases) =>
        prevCases.filter(
          (refCase) => refCase.Bookmark_ID !== refCaseToDelete.Bookmark_ID
        )
      );
      toast.success("Reference case deleted successfully.");
      setDeleteModal(false);
      setRefCaseToDelete(null);

      // Deduct credits
      const deductionSuccess = deductCredits(
        {
          userId,
          creditsToDeduct: 1,
          event: "Deleted reference case.",
        },
        dispatch
      );

      if (!deductionSuccess) {
        console.warn(
          "Failed to deduct credits. Ensure retry or user notification."
        );
      }
    } catch (error) {
      console.error("Error deleting reference case:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveNote = (note) => {
    if (!editNoteItem || !note) return;
    try {
      dispatch(
        updateNote({
          userId: userInfo._id,
          itemId: editNoteItem.Bookmark_ID,
          itemType: editNoteItem.type,
          note,
        })
      );
      setEditNoteItem(null);
    } catch (error) {
      console.error("Error updating note:", error);
    }
  };

  const handleRemoveNoteClick = () => {
    try {
      dispatch(
        removeNote({
          userId: userInfo._id,
          // groupId: selectedGroup?.id,
          itemId: editNoteItem.Bookmark_ID,
          itemType: editNoteItem.type,
        })
      );

      setEditNoteItem(null);
    } catch (error) {
      console.error("Error removing note:", error);
    }
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
    setRefCase(null);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 1,
        }}
      >
        <Typography
          sx={{ fontSize: "18px", fontWeight: "bold", color: "#003D78" }}
        >
          Reference Cases
        </Typography>
      </Box>
      <TableContainer
        sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
        component={Paper}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#003D78", color: "#FFFFFF" }}>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>Title</Box>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Court
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Category
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Citation
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Reference Statute
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fetchingRefCase ? (
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{
                    textAlign: "center",
                    padding: "16px",
                    fontSize: "14px",
                    color: "#777",
                  }}
                >
                  <CircularProgress size={18} sx={{ color: "#003D78" }} />
                </TableCell>
              </TableRow>
            ) : Array.isArray(refCases) && refCases.length > 0 ? (
              refCases.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                    onClick={() => handlePreviewClick(item)}
                  >
                    {formatCaseTitle(item.Title)}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    {formatCourtName(item?.Court)}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    Case
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    {item?.Citation_Name}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    <Stack spacing={0.5}>
                      {item?.Statute_Collection?.map((statute, index) => (
                        <Tooltip key={index} title={statute} arrow>
                          <Typography
                            variant="body2"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontSize: "13px",
                            }}
                          >
                            • {statute}
                          </Typography>
                        </Tooltip>
                      ))}
                    </Stack>
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        size="small"
                        sx={{
                          color: "inherit",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                        onClick={(event) => {
                          setSelectItem(item);
                          setAnchorEl(event.currentTarget);
                        }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            //mt: 3.5,
                            boxShadow:
                              "0px 4px 12px rgba(0, 0, 0, 0.1) !important",
                            borderRadius: "8px",
                            //zIndex: 1,
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            let creditsToDeduct = 1;
                            if (credits <= 0 || credits <= creditsToDeduct) {
                              dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
                              return;
                            }
                            dispatch({
                              type: "CASE_DETAIL_SUCCESS",
                              payload: selectItem,
                            });

                            setOpenCaseInsights(true);
                            setAnchorEl(null);
                            const deductionSuccess = deductCredits(
                              {
                                userId,
                                creditsToDeduct: 1,
                                event: "Open case insights in Bookmark",
                              },
                              dispatch
                            );

                            if (!deductionSuccess) {
                              console.warn(
                                "Failed to deduct credits. Ensure retry or user notification."
                              );
                            }
                          }}
                        >
                          <ListItemIcon>
                            <InsightsIcon
                              sx={{ color: "#4CAF50" }}
                              fontSize="small"
                            />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "13px" }}>
                            Case Insights
                          </Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            let creditsToDeduct = 1;
                            if (credits <= 0 || credits <= creditsToDeduct) {
                              dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
                              return;
                            }
                            handleSummaryClick(item);
                            setAnchorEl(null);
                            const deductionSuccess = deductCredits(
                              {
                                userId,
                                creditsToDeduct: 1,
                                event: "Open summary of Bookmarked item",
                              },
                              dispatch
                            );

                            if (!deductionSuccess) {
                              console.warn(
                                "Failed to deduct credits. Ensure retry or user notification."
                              );
                            }
                          }}
                        >
                          <ListItemIcon>
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              color="#ff9800"
                              fontSize="16px"
                            />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "13px" }}>
                            Summary
                          </Typography>
                        </MenuItem>

                        <MenuItem
                          onClick={() => {
                            setRefCaseToDelete(selectItem);
                            setDeleteModal(true);
                            setAnchorEl(null);
                          }}
                        >
                          <ListItemIcon>
                            <Delete fontSize="small" sx={{ color: red[500] }} />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "13px" }}>
                            Delete
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{
                    textAlign: "center",
                    padding: "16px",
                    fontSize: "14px",
                    color: "#777",
                  }}
                >
                  No Reference Case Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <EditNoteDialog
        open={!!editNoteItem}
        onClose={() => setEditNoteItem(null)}
        initialNote={editNoteItem?.note || ""}
        onSave={handleSaveNote}
        onDelete={handleRemoveNoteClick}
      />
      {openSummary && (
        <CaseSummaryDialog
          open={openSummary}
          onClose={() => setOpenSummary(false)}
          title={selectItem ? formatCaseTitle(selectItem?.Title || "") : ""}
          summary={selectItem?.Detailed_Lawcase_Summary}
        />
      )}

      <CaseDetailDialog
        open={openCaseInsights}
        onClose={() => setOpenCaseInsights(false)}
      />
      {refCase && (
        <CaseLawPreviewDialog
          open={openPreview}
          onClose={handleClosePreview}
          title={refCase ? formatCaseTitle(refCase.Title) : ""}
          court={refCase ? refCase.Court : ""}
          citation={refCase ? refCase.Citation_Name : ""}
          judge={refCase ? refCase.judge_name_clean : ""}
          caseDescriptionContent={refCase ? refCase.Case_Description_HTML : ""}
        />
      )}
      {snackbarMessage && (
        <Snackbar
          open={!!snackbarMessage}
          autoHideDuration={6000}
          onClose={() => setSnackbarMessage(null)}
        >
          <Alert
            onClose={() => setSnackbarMessage(null)}
            severity={snackbarMessage.type}
            sx={{ width: "100%" }}
          >
            {snackbarMessage.text}
          </Alert>
        </Snackbar>
      )}
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={deleteModal}
        onClose={() => {
          setRefCaseToDelete(null);
          setDeleteModal(false);
        }}
        onConfirm={() => {
          if (deleteModal) {
            handleDelete(refCaseToDelete?.Bookmark_ID);
          }
        }}
        title="Confirm Delete"
        contentText={`Are you sure you want to delete the reference case "${formatCaseTitle(
          refCaseToDelete?.Title
        )}"? This action cannot be undone.`}
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        loading={loading}
      />
    </Box>
  );
};
